// Codes follow the Web finance response, which differs for withdrawals and transfers.
const statuses = {
  deposit: {
    1: ['处理中', 'pending'],
    2: ['已完成', 'success'],
    3: ['存款失败', 'failed'],
    4: ['已关闭', 'cancelled'],
  },
  withdrawal: {
    1: ['处理中', 'pending'],
    2: ['处理中', 'pending'],
    3: ['已拒绝', 'failed'],
    4: ['处理中', 'pending'],
    5: ['已完成', 'success'],
    6: ['出款失败', 'failed'],
    7: ['已取消', 'cancelled'],
  },
  transfer: {
    1: ['处理中', 'pending'],
    2: ['成功', 'success'],
    3: ['失败', 'failed'],
  },
}

export function financeRecordStatus(type, record) {
  const state = statuses[type]?.[record.status]
  if (!state) return { label: record.statusName || '未知状态', tone: 'unknown' }
  // Deposit failures and cancellations currently share “已关闭” in the API.
  const label = type === 'deposit' && Number(record.status) === 3
    ? state[0]
    : record.statusName || state[0]
  return { label, tone: state[1] }
}
